import React, {useEffect, useState} from "react";
import trashIcon from '../../img/TrashIcon.svg'
import printIcon from '../../img/PrintIcon.svg'
import {Box, Button, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useSelector} from "react-redux";
import {useMediaQuery} from "react-responsive";

const useStyles = makeStyles(theme => ({
    printBtnWrap: {
        display: `flex`,
        justifyContent: `flex-end`,
        height: `34px`
    },
    printBtn: (props) => ({
        width: props.isLaptop ? `175px` : `264px`,
        '& > img': {
            marginLeft: `20px`,
        },
        '&.MuiButton-root': {
            backgroundColor: '#E5870E',
            '&.Mui-disabled': {
                backgroundColor: theme.palette.primary.light
            }
        }
    }),
    printBtnBox: {
        height: `100%`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`
    }
}));


export const ButtonWrapper = (props) => {
    const isLaptop = useMediaQuery({ query: '(max-width: 1536px)' });
    const stylesProperties = {
        isLaptop: isLaptop
    }
    const classes = useStyles(stylesProperties);
    // const {contentData} = useSelector(state => state);
    // const [selectedRowsNumber, setCountOfSelectedRows] = useState(0);
    const [isDisabled, setDisabled] = useState(false);

    // useEffect(() => {
    //     let selectedRows;
    //     if(contentData.isActivePromosScreen){
    //         if(contentData.isPrintListOpened){
    //             selectedRows = contentData.printListDataForPromos.filter((key) => {
    //                 if(key.selectedRow){
    //                     return key;
    //                 }
    //             });
    //         } else {
    //             selectedRows = contentData.data.filter((key) => {
    //                 if(key.selectedRow){
    //                     return key;
    //                 }
    //             });
    //         }
    //     } else {
    //         if(contentData.isPrintListOpened){
    //             selectedRows = contentData.printListDataForItems.filter((key) => {
    //                 if(key.selectedRow){
    //                     return key;
    //                 }
    //             });
    //         } else {
    //             selectedRows = contentData.dataForRegPrices.filter((key) => {
    //                 if(key.selectedRow){
    //                     return key;
    //                 }
    //             });
    //         }
    //     }
    //     // setCountOfSelectedRows(selectedRows.length);
    // }, [contentData.data,
    //     contentData.dataForRegPrices,
    //     contentData.printListDataForPromos,
    //     contentData.printListDataForItems,
    //     contentData.isActivePromosScreen,
    //     contentData.isPrintListOpened
    // ]);

    useEffect(() => {
        setDisabled(props.numberOfPages === 0 || props.numberOfPages > 500);
    }, [props.numberOfPages])
    let icon;
    // disabled = props.numberOfPages === 0 || props.numberOfPages > 500;
    if(props.icon === 'trash'){
        icon = trashIcon;
    } else if(props.icon === 'print'){
        icon = printIcon;
    }
    return (
        <Box className={classes.printBtnWrap}>
            <Button onClick={props.onClick} disabled={isDisabled} className={classes.printBtn}>
                <Grid container>
                    <Grid item xs={2}>
                        <Box className={classes.printBtnBox}>
                            <img src={icon} alt={``}/>
                        </Box>
                    </Grid>
                    <Grid item xs>
                        <Box className={classes.printBtnBox}>
                            <Typography variant={isLaptop ? `body1` : `body2`} color={`white`}>
                                {props.value}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Button>
        </Box>
    )
};
